"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendRecommenderSessionEvent = exports.deleteKeysRecommenderSession = exports.updateRecommenderSession = exports.getRecommenderSession = void 0;
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var EventPublisher_1 = require("./EventPublisher");
var Events_1 = require("./Events");
var LoggerService_1 = require("./LoggerService");
var StatsDClient_1 = require("./StatsDClient");
var RECOMMENDER_SESSION_STORAGE_NAME = "recommenderSession";
function rollRandomString() {
    return "".concat(Math.random()).padEnd(25, "0").slice(0, 25);
}
var salt = rollRandomString();
function getRecommenderSession() {
    try {
        var rawCtx = sessionStorage.getItem(RECOMMENDER_SESSION_STORAGE_NAME);
        var session = rawCtx ? JSON.parse(rawCtx) : {};
        if (!rawCtx || !session.sessionId) {
            session.sessionId = btoa(JSON.stringify({
                seed1: rollRandomString(),
                seed2: rollRandomString(),
                salt: salt,
                created: "".concat(Date.now()).padEnd(20, "0").slice(0, 20),
            }));
            StatsDClient_1.statsd.count("recommenders.session.new-session");
            sessionStorage.setItem(RECOMMENDER_SESSION_STORAGE_NAME, JSON.stringify(session));
        }
        return session;
    }
    catch (error) {
        LoggerService_1.logger.error("unexpected error getting recommender session", error);
        return { sessionId: "whoops" };
    }
}
exports.getRecommenderSession = getRecommenderSession;
function updateRecommenderSession(updates) {
    var e_1, _a;
    try {
        var session = getRecommenderSession();
        try {
            for (var _b = __values(Object.entries(updates)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (key && value !== undefined && key !== "sessionId") {
                    // @ts-ignore
                    session[key] = value;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        sessionStorage.setItem(RECOMMENDER_SESSION_STORAGE_NAME, JSON.stringify(session));
        return session;
    }
    catch (error) {
        LoggerService_1.logger.error("unexpected error updating recommender session!", error);
        return {};
    }
}
exports.updateRecommenderSession = updateRecommenderSession;
function deleteKeysRecommenderSession() {
    var e_2, _a;
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    try {
        var session = getRecommenderSession();
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                if (key !== "sessionId") {
                    // @ts-ignore
                    delete session[key];
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        sessionStorage.setItem(RECOMMENDER_SESSION_STORAGE_NAME, JSON.stringify(session));
        return session;
    }
    catch (error) {
        LoggerService_1.logger.error("unexpected error deleting keys from recommender session!", error);
        return {};
    }
}
exports.deleteKeysRecommenderSession = deleteKeysRecommenderSession;
var sendRecommenderSessionEvent = function (action) {
    var _a;
    var session = getRecommenderSession();
    if (!(session === null || session === void 0 ? void 0 : session[action])) {
        EventPublisher_1.publisher.send(Events_1.Events.sessionAction, __assign({ action: action }, session), undefined, false);
        updateRecommenderSession((_a = {}, _a[action] = true, _a));
    }
};
exports.sendRecommenderSessionEvent = sendRecommenderSessionEvent;
//# sourceMappingURL=RecommenderSession.js.map